import { Box } from "@raca2022/uikit";
import styled from "styled-components";

export const Wapper = styled(Box)`
  width: 100%;
  padding: 5vw 4vw 0px;
  background-color: #3d4856;
  @media only screen and (min-width: 1920px) {
    padding: 100px 80px 0px;
  }
`;
export const Container = styled(Box)`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  flex-wrap: wrap;
  h3 {
    font-weight: 600;
    font-size: 24px;
    line-height: 110%;
    color: #f2f9f9;
    font-family: "PoppinsSemiBold";
    margin-bottom: 46px;
    text-align: center;
    width: 100%;
    margin-top: 72px;
  }
  div{
    h3{
        text-align: left;
        margin-top: 0px;
        margin-bottom: 16px;
    }
  }
  p , a {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 170%;
    color: #8094ae;
    font-family: "PoppinsMedium";
  }
  input {
    background: #ffffff;
    border-radius: 10px;
    max-width: 240px;
    margin-top: 14px;
    margin-right: 8px;
    border: none;
    outline: none;
    height: 47px;
    padding: 10px 20px;
  }
  button {
    background: #009768;
    border-radius: 10px;
    font-weight: 500;
    font-size: 13px;
    line-height: 110%;
    color: #F2F9F9;
    padding: 17px 23px;
    border: none;
    outline: none;
  }
  @media only screen and (max-width: 1030px) {
    justify-content: space-between;
    h3{
      font-size: 2.8vw;
      margin-top: 10vw;
      margin-bottom: 7.4vw;
    }
    p,a{
      font-size: 2.33vw;
    }
    div{
      width: 25%;
      :nth-child(5){
        width: 100%;
        display: flex;
        margin-top: 30px;
        div{
          width: 70%;
          :last-child{
            display: flex;
            input{
              align-self: stretch;
              height: 7.94vw;
              margin-top: 0px;
              width: 37vw;
              min-height: 32px;
              padding: 5px 10px;
            }
            button{
              align-self: stretch;
              height: 7.94vw;
              padding: 0px;
              width: 19vw;
              min-height: 32px;
              min-width: 85px;
              font-size: 2.33vw;
            }
          }
        }
      }
    }
  }
`;
export const Social = styled(Box)`
  width: 100%;
  max-width: 547px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 110px;
  @media only screen and (max-width: 1030px) {
    width: 100% !important;
    margin: auto ;
    margin-bottom: 6vw;
    img{
      width: 6vw;
    }
  }
`
export const Coppyright = styled(Box)`
  width: 100%;
  height: 100%;
  background: #314257;
  height: 69px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 80px;
  img{
    margin-right: 8px;
  }
  p{
    font-weight: 400;
    font-size: 12px;
    line-height: 110%;
    color: #8094AE;
    font-family: 'PoppinsRegular';
    text-align: center;
    width: fit-content;
  }
`
